import React from "react";
import Dropzone from "react-dropzone";
import dragdropIcon from 'Flow2/components/CustomCollections/CustomImages/dragdrop.png';
import { connect } from "react-redux";
import * as actions from "store/actions/index";
import * as classes from "./CustomDragDropBox.module.scss";

class CustomDragDropBox extends React.Component {
    state = { warningMsg: "" };

    onDrop = (accepted, rejected) => {
        if (Object.keys(rejected).length !== 0) {
            const message = "Please submit valid file type";
            this.setState({ warningMsg: message });
        } else {
            this.props.addFile(accepted);
            this.setState({ warningMsg: "" });
        }
    };

    render() {
        const render = <div className={classes.HeaderBox}>
            <img className={classes.Icons} src={dragdropIcon} alt=""></img>
            <div className={classes.Heading} style={{ alignItems: "center" }}> Drag & Drop here</div></div>

        return (
            <div className={classes.DragDropBoxContainer}>
                <div className={classes.DragDropBox}>

                    <Dropzone
                        style={{
                            width: "100%",
                            height: "50px",
                            objectFit: "cover",
                            objectPosition: "center",
                            border: "1px dashed #c4c4c4",
                            display: "flex",
                            justifyContent: "center"

                        }}
                        multiple={true}

                        minSize={0}
                        onDrop={(accepted, rejected) => this.onDrop(accepted, rejected)}
                    >
                        {({ isDragAccept, isDragReject, acceptedFiles, rejectedFiles }) => {
                            if (isDragReject) return "Please submit a valid file";
                            return render;
                        }}
                    </Dropzone>

                </div>

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        dragdropCounter: state.ui.uploadDragdropCounter
    }
}

const mapDispatchToProps = dispatch => {
    return {
        uploadAddDragDrop: (counter) => dispatch(actions.uploadAddDragDrop(counter))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomDragDropBox);



